import { FragmentType, gql, useFragment } from 'graphql-generated'
import { GetText } from 'lib/gettext'

const ROLE_FRAGMENT = gql(`
  fragment PublicProfile_Profile_Role on auth_user {
    managing_editor {
      id
    }
    regional_editor {
      title
    }
  }
`)

type RoleProps = {
  userRef: FragmentType<typeof ROLE_FRAGMENT>
}

export default function Role(props: RoleProps) {
  const { managing_editor: managingEditor, regional_editor: regionalEditor } =
    useFragment(ROLE_FRAGMENT, props.userRef)

  return (
    <div className="capitalize [&>*:not(:last-child)]:after:content-[',_']">
      <span>
        <GetText>Expert</GetText>
      </span>

      {managingEditor && (
        <span>
          <GetText>Managing editor</GetText>
        </span>
      )}
      {regionalEditor && (
        <span>
          {regionalEditor.title ? (
            <GetText data={{ title: regionalEditor.title }}>
              Regional editor (%(title)s)
            </GetText>
          ) : (
            <GetText>Regional editor</GetText>
          )}
        </span>
      )}
    </div>
  )
}
